<template>
  <div>
    <div class="bottom-list">
      <div
        class="bottom-list-item"
        :class="{ actived: index === currentIndex }"
        v-for="(item, index) in bottomList"
        :key="index"
        @click="changeBtn(index)"
      >
        {{ item }}
      </div>
    </div>
    <div v-if="currentIndex === 0">
      <el-input
        type="textarea"
        :disabled="userInfo.canDelete == 0"
        v-model="remark"
      ></el-input>
      <div class="save">
        <div class="save-bottom" @click="saveForm">保存</div>
      </div>
    </div>
    <div v-if="currentIndex === 1">
      <div class="videoBox" v-if="videoList.length">
        <div
          class="video-item"
          v-for="(item, index) in videoList"
          :key="index"
          @click="toPlayVideo(item)"
          :style="{
            'margin-right': $px2rem(`${16}px`),
          }"
        >
          <img :src="item.ext1" class="video-src" alt="" />
          <img class="play-icon" src="@/assets/video-play.png" alt="" />
          <div class="zhezhao-small"></div>
        </div>
      </div>
      <div v-else>
        <none-data></none-data>
      </div>
    </div>
    <div v-if="currentIndex === 2">
      <div class="videoBox" v-if="imgList.length">
        <div
          class="video-item"
          v-for="(item, index) in imgList"
          :key="index"
          :style="{
            'margin-right': $px2rem(`${16}px`),
          }"
        >
          <img :src="item.attaSource" class="video-src" alt="" />
        </div>
      </div>
      <div v-else>
        <none-data></none-data>
      </div>
    </div>
    <el-dialog
      :visible.sync="showVideo"
      :close-on-click-modal="false"
      :before-close="handleClose"
      :modal="false"
      width="40%"
      center
      top="20vh"
      v-if="showVideo"
    >
      <div>
        <video
          v-if="videoSrc"
          class="videoItem"
          ref="videoDom"
          :src="videoSrc"
          :autoPlay="autoPlay"
          controls
        ></video>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { addHall, getHallatta, getVideoById } from "@/api/request";
import NoneData from "@/pages/components/none-data.vue";
export default {
  props: {
    userInfo: Object,
  },
  components: { NoneData },
  data() {
    return {
      bottomList: ["生平介绍"],
      currentIndex: 0,
      remark: this.userInfo.remark,
      videoList: [],
      imgList: [],
      showVideo: false,
      videoSrc: "",
      autoPlay: true,
    };
  },
  created() {},
  methods: {
    changeBtn(index) {
      this.currentIndex = index;
      if (this.currentIndex === 1) {
        getHallatta({
          refId: this.userInfo.id,
          attaType: 2,
        }).then((res) => {
          this.videoList = res.data.result;
        });
      }
      if (this.currentIndex === 2) {
        getHallatta({
          refId: this.userInfo.id,
          attaType: 1,
        }).then((res) => {
          this.imgList = res.data.result;
        });
      }
    },
    toPlayVideo(e) {
      getVideoById(e.attaSource).then((res) => {
        this.videoSrc = res.data.result.playInfoList.playInfo[0].playURL;
        this.showVideo = true;
        this.$nextTick(() => {
          this.$refs.videoDom.load();
          this.autoPlay = true;
        });
      });
    },
    handleClose() {
      if (this.$refs.videoDom) {
        this.$nextTick(() => {
          this.$refs.videoDom.pause();
          this.showVideo = false;
        });
        this.autoPlay = false;
      }
    },
    saveForm() {
      if (this.userInfo.canDelete == 0) {
        this.$message.error("暂无权限，不可编辑!");
        return;
      }
      this.$emit("updateForm", this.remark);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./main.scss";
.bottom-list {
  display: flex;
  margin-bottom: 19px;
  &-item {
    width: 100px;
    border-radius: 8px;
    line-height: 38px;
    color: #8a8a8a;
    font-size: 16px;
    cursor: pointer;
  }
  .actived {
    background: #ecf2f0;
    color: #45796e;
  }
}
.save {
  display: flex;
  justify-content: flex-end;
  padding: 25px 0 43px 0;
  .save-bottom {
    width: 240px;
    line-height: 50px;
    border-radius: 40px;
    color: #ffffff;
    background: #45796e;
    cursor: pointer;
  }
}
:deep .el-textarea__inner {
  min-height: 372px !important;
  font-size: 16px;
  background: #f4f5f7;
  border-color: #f4f5f7;
}
</style>
